import { all } from "redux-saga/effects";
import watchFetchSpicesAsync from "./spicesSaga";
import watchFetchIncensesAsync from "./incensesSaga";
import watchFetchHomeLookupsAsync from "./homeLookupsSaga";
import watchFetchContactsAsync from "./contactsSaga";
import watchPostOrdersAsync from "./postOrdersSaga";
import watchFetchOrdersAsync from "./myOrdersSaga";

export default function* rootSaga() {
  yield all([
    watchFetchSpicesAsync(),
    watchFetchIncensesAsync(),
    watchFetchHomeLookupsAsync(),
    watchFetchContactsAsync(),
    watchPostOrdersAsync(),
    watchFetchOrdersAsync(),
  ]);
}
